import { render, staticRenderFns } from "./ship-tab-view.vue?vue&type=template&id=389c229e&scoped=true&"
import script from "./ship-tab-view.vue?vue&type=script&lang=js&"
export * from "./ship-tab-view.vue?vue&type=script&lang=js&"
import style0 from "./ship-tab-view.vue?vue&type=style&index=0&id=389c229e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389c229e",
  null
  
)

export default component.exports